// PLAN.md §2.2 + §3.9 — BTC price label, tick countdown, feed-status dot.

import { useEffect, useState } from 'react'
import { AnimateNumber } from 'motion-plus/react'
import { useStore } from '../../store.js'

const TICK_MS = 1000

export function PriceHeader() {
  const price = useStore((s) => s.price)
  const feedStatus = useStore((s) => s.feed_status)
  const [tickStartedAt, setTickStartedAt] = useState(Date.now())

  // Reset countdown anchor on each new tick.
  const tick_id = useStore((s) => s.tick_id)
  useEffect(() => {
    setTickStartedAt(Date.now())
  }, [tick_id])

  const [countdown, setCountdown] = useState(1.0)
  useEffect(() => {
    const id = setInterval(() => {
      const elapsed = Math.min(TICK_MS, Date.now() - tickStartedAt)
      setCountdown(Math.max(0, (TICK_MS - elapsed) / 1000))
    }, 50)
    return () => clearInterval(id)
  }, [tickStartedAt])

  return (
    <div className="flex flex-col items-center gap-1">
      <div className="flex items-center gap-2">
        <FeedStatusDot status={feedStatus} />
        {price === null ? (
          <span className="text-headline text-grey tabular-nums">$ —</span>
        ) : (
          <span className="text-headline text-black tabular-nums">
            <AnimateNumber
              prefix="$"
              locales="en-US"
              format={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }}
            >
              {price}
            </AnimateNumber>
          </span>
        )}
      </div>
      <span className="text-label text-grey tabular-nums">
        next tick · {countdown.toFixed(1)}s
      </span>
      {feedStatus === 'delayed_60s' && price !== null && (
        <span className="text-label text-red mt-1">
          BTC feed delayed — game continues at last known price
        </span>
      )}
    </div>
  )
}

function FeedStatusDot({ status }: { status: 'fresh' | 'delayed_5s' | 'delayed_60s' }) {
  if (status === 'fresh') {
    return <span className="w-2 h-2 rounded-full bg-green" aria-hidden />
  }
  if (status === 'delayed_5s') {
    return <span className="w-2 h-2 rounded-full bg-amber" aria-hidden title="feed delayed" />
  }
  return <span className="w-2 h-2 rounded-full bg-red" aria-hidden title="feed delayed" />
}
